import { render, staticRenderFns } from "./no-side-bar.vue?vue&type=template&id=2997a6cb&"
import script from "./no-side-bar.vue?vue&type=script&lang=js&"
export * from "./no-side-bar.vue?vue&type=script&lang=js&"
import style0 from "./no-side-bar.vue?vue&type=style&index=0&id=2997a6cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports